const map = {
	"./amazon_ses.svg": 91389,
	"./google.svg": 41450,
	"./outlook.svg": 95900,
	"./sendgrid.svg": 27097,
	"./sendinblue.svg": 50832,
	"./smtp.svg": 37219
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99599;